
  import { defineComponent } from 'vue';

  import type { PropType } from 'vue';

  export default defineComponent({
    name: 'DocumentIcon',

    props: {
      fileType: {
        type: String as PropType<string>,
        default: 'PDF',
      },
    },
  });
